"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractsHttpService = void 0;
const bulk_create_contracts_1 = require("../../types/doctor-substitutes/bulk-create-contracts");
const bulk_remind_contracts_1 = require("../../types/doctor-substitutes/bulk-remind-contracts");
const delete_doctor_subtitute_contract_1 = require("../../types/doctor-substitutes/delete-doctor-subtitute-contract");
const get_doctor_substitute_contract_details_1 = require("../../types/doctor-substitutes/get-doctor-substitute-contract-details");
const get_doctor_substitute_contracts_list_1 = require("../../types/doctor-substitutes/get-doctor-substitute-contracts-list");
const http_service_1 = require("../http.service");
class ContractsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/contracts`);
    }
    getList(payload) {
        const params = {
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        if (payload.officeId) {
            params.officeId = payload.officeId;
        }
        if (payload.search) {
            params.search = payload.search;
        }
        if (payload.period) {
            params.period = JSON.stringify(payload.period);
        }
        if (payload.signatureStatus && payload.signatureStatus !== 'all') {
            params.signatureStatus = payload.signatureStatus;
        }
        return this.getEntityList('', {
            params,
            schema: get_doctor_substitute_contracts_list_1.getDoctorSubstituteContractsListApiResponseSchema,
        });
    }
    bulkRemind(payload) {
        return this.post('/bulk-remind', {
            body: payload,
            schema: bulk_remind_contracts_1.bulkRemindContractsApiResponseSchema,
        });
    }
    previewBulkCreate(payload) {
        return this.post('/bulk-create/preview', {
            body: payload,
            schema: bulk_create_contracts_1.bulkCreateContractsPreviewApiResponseSchema,
        });
    }
    bulkCreate(payload) {
        return this.post('/bulk-create', {
            body: payload,
            schema: bulk_create_contracts_1.bulkCreateContractsApiResponseSchema,
        });
    }
    getById(contractId) {
        return this.getEntity(`/${contractId}`, {
            schema: get_doctor_substitute_contract_details_1.getDoctorSubstituteContractDetailsApiResponseSchema,
        });
    }
    deleteById(contractId) {
        return this.delete(`/${contractId}`, {
            schema: delete_doctor_subtitute_contract_1.deleteDoctorSubstituteContractApiResponseSchema,
        });
    }
}
exports.ContractsHttpService = ContractsHttpService;
